import React from 'react';
import styled from 'styled-components';
import { H1 } from '../../../components/Typography/Typography';
import { media } from '../../../components/style-utils';

export default function Headline(props) {
  return (
    <Container>
      <StyledH1>
        <Colored>Congratulations!</Colored>
        🎉 Welcome to The 167 mentorship program. You're&nbsp;in.
      </StyledH1>
    </Container>
  );
}

const Container = styled.div`
  padding: 7rem 3rem;
`;

const Colored = styled.span`
  color: var(--colorPrimaryMedium);
`;

const StyledH1 = styled(H1)`
  max-width: 85rem;
  margin: 0 auto;

  ${media.phoneOnly`
    font-size: 3.7rem;
  `}
`;



// WEBPACK FOOTER //
// ./src/routes/ThankYou/components/Headline.js